'use strict';

export default class PageInfo {

    constructor(pageInfo) {
        this.hasNextPage     = pageInfo.hasOwnProperty('hasNextPage') ? pageInfo.hasNextPage : false;
        this.hasPreviousPage = pageInfo.hasOwnProperty('hasPreviousPage') ? pageInfo.hasPreviousPage : false;;
        this.startCursor     = pageInfo.hasOwnProperty('startCursor') ? pageInfo.startCursor : false;;
        this.endCursor       = pageInfo.hasOwnProperty('endCursor') ? pageInfo.endCursor : false;;
    }
}


// WEBPACK FOOTER //
// ./src/graphql/PageInfo.js